
import React, { useEffect, useState, useCallback } from "react";
import axiosConfig from "../config";
import "./pages.css";
import { useAuth } from "../contexts/AuthContext";
import { formatDate } from "../util";


export default function Home () {

  const [operations, setOperations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // grab the session and loading thing
  const { user, loading: authLoading } = useAuth();
  // grab the email from the session's user
  const email = user?.email;

  const fetchOperations = useCallback(async () => {
    try {
      setLoading(true);

      if (authLoading || !email)
        return;

      const res = await axiosConfig.get("/operations", {
        params: {
          page: 1,
          pageSize: 5,
          sortBy: "theatreDate",
          sortOrder: "asc",
          // filter by surgeon id (or email as i like to call it)
          filter: JSON.stringify({ "surgeonId": email })
        }
      });
      
      const data = res.data; 
      setOperations(data.operations);
    } 
    
      catch (err) {
      console.error(err);
      setError("Failed to fetch operations.");
    } finally {
      setLoading(false);
    }
  }, [email, authLoading]);

  useEffect(() => {
    fetchOperations();
  }, [fetchOperations]);

  const upcoming = operations[0];
  const others = operations.slice(1);



  return (
    <div className="home-container">
      <h2 className="section-header"> Upcoming Operation </h2>

      {loading || authLoading ? (
        <p> Loading... </p>
      ) : error ? (
        <p className="error"> {error} </p>
      ) : upcoming ? (
        <div className="highlighted-operation">
          <div className="info-card">
            <h4> Patient Information </h4>
            <p><strong> Full Name: </strong> {upcoming.patientName} </p>
            <p><strong> CHI Number: </strong> {upcoming.chId} </p>
            <p><strong> Surgery Side: </strong> {upcoming.surgerySide === "L" ? "Left" : upcoming.surgerySide === "R" ? "Right" : "Unknown"} </p>
          </div>
          <div className="info-card">
            <h4> Operation Information </h4>
            <p><strong> Type: </strong> {upcoming.operationType === 0  ? "Hip Replacement" : upcoming.operationType === 1  ? "Knee Replacement" : "Unknown" } </p>
            <p><strong> Theatre Date: </strong> {formatDate(upcoming.theatreDate)} </p>
            <p><strong> Priority Score: </strong> {upcoming.priorityScore}</p>
          </div>
        </div>
      ) : (
        <p> No upcoming operations. </p>
      )}

      <h3 className="section-subheader">Other Upcoming Operations</h3>
      <ul className="operation-list">
        {others.map((op, index) => (
          <li key={op._id} className="operation-item">
            <div className="operation-index">#{index + 2}</div>
            <div className="operation-details">
              <div className="operation-name"><strong>{op.patientName}</strong></div>
              <div className="operation-type-date">
                <em>
                  {op.operationType === 0
                    ? "Hip Replacement"
                    : op.operationType === 1
                    ? "Knee Replacement"
                    : "Unknown"}
                </em>{" "}
                on <strong>{formatDate(op.theatreDate)}</strong>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
  
